<template>
  <div id="messageMrg">
    <TopList :navList="navList" @setType="setType"></TopList>
    <All></All>
    <!--    <Article v-else></Article>-->
  </div>
</template>

<script>
import TopList from "../../components/topList";
import All from "./components/all";
// import Article from "./components/article";

export default {
  name: "index",
  components: {
    TopList,
    All,
    // Article,
  },
  data() {
    return {
      type: 0,
      navList: ["全部", "文章"],
    };
  },
  methods: {
    setType(e) {
      this.type = e;
    },
  },
};
</script>

<style lang="scss" scoped>
#messageMrg {
  width: 1200px;
  // height: 300px;
  //background: pink;
}
</style>
